/* Maison Sahari v3 (01-10) : barre de navigation. Condensation, masquage mobile, page active, clavier, tiroir. Sans requête réseau. */
(function () {
  'use strict';
  var d = document, H = d.documentElement, en = (H.lang || '').slice(0, 2) === 'en',
    mq = matchMedia('(max-width:989px)'), y0 = 0, dir = 0, c = 0, h = 0, t = 0, fx = 0, sw;
  function q(s, r) { return (r || d).querySelector(s); }
  function qa(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }
  function tg(a, on) { on ? H.setAttribute(a, '') : H.removeAttribute(a); }
  function nl(p) { return p === '/en' ? '/' : p.indexOf('/en/') === 0 ? p.slice(3) : p; }
  function busy() {
    var hd = q('header-component');
    return !!(q('.menu-open,dialog[open]') || q('header-menu [aria-expanded="true"]') || (hd && q(':focus-visible', hd)));
  }
  /* défilement : condensé après 40 px ; masqué en descendant (mobile, tablette), visible en remontant.
     Sur ordinateur Horizon fait défiler .page-wrapper, sur mobile la fenêtre : on suit la source du dernier défilement. */
  function sc() {
    var y = sw ? sw.scrollTop : pageYOffset, v = y - y0, n;
    t = 0;
    if (v > 5 || v < -5) { dir = v > 0 ? 1 : -1; y0 = y; }
    n = y > (c ? 20 : 40) ? 1 : 0;
    if (n !== c) { c = n; tg('data-ms-c', n); }
    n = mq.matches && dir > 0 && y > 90 && !busy() ? 1 : 0;
    if (n !== h) { h = n; tg('data-ms-h', n); }
  }
  d.addEventListener('scroll', function (e) {
    var x = e.target;
    if (x === d || (x.classList && x.classList.contains('page-wrapper'))) {
      sw = x === d ? null : x;
      t || (t = requestAnimationFrame(sc));
    }
  }, { passive: true, capture: true });
  /* la barre de liens vit dans une liste « overflow-list » à débordement masqué : donner le focus à un lien du panneau (qui dépasse sous elle)
     la faisait défiler de ~76 px et les liens de la barre disparaissaient ; on la remet à zéro avant l'affichage suivant */
  function rs() {
    var o = q('overflow-list'), p = o && o.shadowRoot && o.shadowRoot.querySelector('[part="list"]');
    if (p && (p.scrollTop || p.scrollLeft)) { p.scrollTop = 0; p.scrollLeft = 0; }
  }
  d.addEventListener('focusin', function (e) {
    var x = e.target.closest ? e.target.closest('header-component') : null;
    if (!x) return;
    if (h) { h = 0; dir = 0; tg('data-ms-h', 0); }
    setTimeout(rs, 0); requestAnimationFrame(rs);
  });
  /* page courante : aria-current="page" et trait or */
  function sg(x) { x = x.split('/')[1]; return x === 'products' ? 'collections' : x; }
  function ac() {
    var p = nl(location.pathname);
    qa('.menu-list__list-item>a.menu-list__link,.menu-drawer__menu-item--mainlist').forEach(function (a) {
      var li = a.closest('li'), on = [a].concat(qa('.mega-menu__link,.menu-drawer__menu-item--child', li)).some(function (l) {
        var k = nl(l.pathname);
        return k !== '/' && (sg(k) === 'pages' ? k === p : sg(k) === sg(p));
      });
      on ? a.setAttribute('aria-current', 'page') : a.removeAttribute('aria-current');
    });
  }
  /* fermeture d'un panneau : on remet à zéro l'état interne d'Horizon (aria-expanded du lien ET du conteneur header-menu),
     sinon Échap laisse aria-expanded="true" et la flèche bas ne rouvre plus le panneau */
  function cm() {
    var s = q('header-menu .menu-list__submenu[data-active]'), li = s && s.closest('.menu-list__list-item');
    if (li) li.dispatchEvent(new PointerEvent('pointerleave'));
    qa('header-menu[aria-expanded="true"],header-menu [aria-expanded="true"]').forEach(function (n) { n.setAttribute('aria-expanded', 'false'); });
    rs();
  }
  /* clavier : Échap ferme (après maison-sahari-v3.js qui rend le focus au déclencheur) ; flèche bas ouvre et parcourt le panneau ;
     toute navigation au clavier lève le masquage posé par Échap (sinon le panneau resterait caché tant que la souris ne bouge pas) */
  d.addEventListener('keydown', function (e) {
    var k = e.key, a = e.target, l, i, np = { preventScroll: true };
    if (!a.matches) return;
    if (k === 'Escape') { cm(); return; }
    if (H.hasAttribute('data-ms-esc') && /^(Tab|Arrow(Up|Down|Left|Right)|Enter| )$/.test(k) && a.closest('header-menu')) H.removeAttribute('data-ms-esc');
    if (k === 'ArrowDown' && a.matches('.menu-list__link[aria-haspopup]')) {
      if (a.getAttribute('aria-expanded') !== 'true') a.parentNode.dispatchEvent(new PointerEvent('pointerenter'));
      l = q('.mega-menu__link', a.parentNode);
      if (l) { e.preventDefault(); l.focus(np); }
    } else if ((k === 'ArrowDown' || k === 'ArrowUp') && a.matches('.mega-menu__link')) {
      l = qa('.mega-menu__link', a.closest('.mega-menu'));
      i = l.indexOf(a) + (k === 'ArrowDown' ? 1 : -1);
      e.preventDefault();
      if (l[i]) l[i].focus(np); else if (k === 'ArrowUp') q('.menu-list__link[aria-expanded="true"]').focus(np);
    }
  });
  d.addEventListener('pointerdown', function (e) {
    if (q('header-menu [aria-expanded="true"]') && !e.target.closest('header-menu')) { H.setAttribute('data-ms-esc', ''); cm(); }
  }, { passive: true });
  /* panneau « La Maison » : un seul lien paraissait vide à côté de Boutique ; on ajoute en tête la page de la rubrique elle-même (même lien que le titre) */
  function mh() {
    qa('.menu-list__list-item>a.menu-list__link[aria-haspopup]').forEach(function (a) {
      var ul = q('.mega-menu__list', a.parentNode), li, lk;
      if (nl(a.pathname) !== '/pages/maison-sahari-histoire' || !ul || q('.ms-mh', ul)) return;
      li = d.createElement('li');
      li.className = 'mega-menu__column mega-menu__column--span-1 ms-mh';
      li.innerHTML = '<div><a href="' + a.getAttribute('href') + '" class="mega-menu__link"><span class="wrap-text">' + (en ? 'Our story' : 'Notre histoire') + '</span></a></div>';
      lk = li.firstChild.firstChild;
      if (nl(location.pathname) === nl(a.pathname)) lk.setAttribute('aria-current', 'page');
      ul.insertBefore(li, ul.firstChild);
    });
  }
  /* tiroir mobile : accès rapide recherche, panier, langue */
  function dq() {
    var n = q('.menu-drawer__navigation'), r, p = nl(location.pathname), s = location.search;
    if (!n || q('.ms-dq')) return;
    r = d.createElement('div');
    r.className = 'ms-dq menu-drawer__animated-element';
    r.style.setProperty('--menu-drawer-animation-index', 6);
    r.innerHTML = '<button type="button" class="ms-dq__b" data-a="s">' + (en ? 'Search' : 'Rechercher') + '</button>' +
      '<button type="button" class="ms-dq__b" data-a="c">' + (en ? 'Cart' : 'Panier') + '</button>' +
      '<span class="ms-dq__l"><a href="' + p + s + '" lang="fr"' + (en ? '' : ' aria-current="true"') + '>FR</a>' +
      '<a href="/en' + (p === '/' ? '' : p) + s + '" lang="en"' + (en ? ' aria-current="true"' : '') + '>EN</a></span>';
    n.after(r);
    r.addEventListener('click', function (e) {
      var b = e.target.closest('button'), x = q('.menu-drawer__close-button');
      if (!b) return;
      if (x) x.click();
      setTimeout(function () {
        var o = b.dataset.a === 's' ? qa('.search-action button').filter(function (z) { return z.offsetParent; })[0] : (q('cart-icon') || {}).parentNode;
        if (o && o.click) o.click();
      }, 340);
    });
  }
  /* Horizon reconstruit une partie du tiroir juste après le chargement : on réapplique page active, panneau La Maison et accès rapide */
  function fix() { fx = 0; mh(); ac(); dq(); }
  function init() {
    var g = q('#header-group');
    fix(); sc();
    if (g) new MutationObserver(function () { fx || (fx = setTimeout(fix, 60)); }).observe(g, { childList: true, subtree: true });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();